import React from 'react';
import { PagePath, FormSetting } from '../../components';

const Settings: React.FC = () => {
  return (
    <div>
      <PagePath
        title="Editar Configurações"
        goBack={{
          title: 'Dashboard',
          goBackPath: '/home/dashboard-admin',
        }}
      />
      <FormSetting />
    </div>
  );
};

export default Settings;
